import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";

import { GqlFilterOptionSelect } from "~/__generated__";

type Props = {
    sx?: SxProps<Theme>;
    option: GqlFilterOptionSelect;
    value: string;
    onChange: (value: string | null) => void;
};

export default function SelectFilter({ sx, option, value, onChange }: Props) {
    return (
        <Autocomplete
            sx={sx}
            options={option.options}
            getOptionLabel={option => option.label}
            getOptionKey={option => option.value}
            onChange={(_e, v) => onChange(v?.value || null)}
            value={option.options.find(e => e.value === value) || null}
            renderInput={params => (
                <TextField sx={{ width: "216px" }} {...params} variant="outlined" label={option.label} />
            )}
        />
    );
}
